import { walletWithdrawalService } from "../../helpers/walletWithdrawalService";

export const state = {
  getAllPendingRequest: [],
  getAllApprovedRequest: [],
  getAllDeclinedRequest: [],
  pendingRequestCount: "",
  approvedRequestCount: "",
  declinedRequestCount:"",
  pagination: {},
  loading: true,
};

export const mutations = {
  getAllPendingRequest(state, payload) {
    state.getAllPendingRequest = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.pendingRequestCount = payload.result.total;
  },
  getAllApprovedRequest(state, payload) {
    state.getAllApprovedRequest = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.approvedRequestCount = payload.result.total;
  },
  getAllDeclinedRequest(state, payload) {
    state.getAllDeclinedRequest = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.declinedRequestCount = payload.result.total;
  },
  getPendingListRequest(state) {
    state.loading = true;
  },
  getPrePayment(state, payload) {
    state.user = payload.result;
  },
  getPendingRequestListFailure(state) {
    state.loading = false;
  },
};

export const actions = {
  async getPendingRequest({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getPendingListRequest");
    await walletWithdrawalService.getPendingRequest(data).then(
      (response) => {
        commit("getAllPendingRequest", response.data);
      },
      (error) => {
        commit("getPendingRequestListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async requestStatusChange({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getPendingListRequest");
    await walletWithdrawalService.requestStatusChange(data).then(
      (response) => {
        if (response.data.code == 200) {
          dispatch("alert/success", response.data.msg, { root: true });
          dispatch("getPendingRequest");
        }
      },
      (error) => {
        commit("getPendingRequestListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getApprovedRequest({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getPendingListRequest");
    await walletWithdrawalService.getApprovedRequest(data).then(
      (response) => {
        commit("getAllApprovedRequest", response.data);
      },
      (error) => {
        commit("getPendingRequestListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getDeclinedRequest({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getPendingListRequest");
    await walletWithdrawalService.getDeclinedRequest(data).then(
      (response) => {
        commit("getAllDeclinedRequest", response.data);
      },
      (error) => {
        commit("getPendingRequestListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
};
export const getters = {
  loading: (state) => state.loading,
  getAllPendingRequest: (state) => state.getAllPendingRequest,
  getAllApprovedRequest: (state) => state.getAllApprovedRequest,
  getAllDeclinedRequest: (state) => state.getAllDeclinedRequest,
  pendingRequestCount: (state) => state.pendingRequestCount,
  approvedRequestCount: (state) => state.approvedRequestCount,
  declinedRequestCount: (state) => state.declinedRequestCount,
  pagination: (state) => state.pagination,
};
